import { render, staticRenderFns } from "./Fs.vue?vue&type=template&id=87dbb934&scoped=true&"
import script from "./Fs.vue?vue&type=script&lang=js&"
export * from "./Fs.vue?vue&type=script&lang=js&"
import style0 from "./Fs.vue?vue&type=style&index=0&id=87dbb934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dbb934",
  null
  
)

export default component.exports